// extracted by mini-css-extract-plugin
export default {"colorline":"MtdHXl3Q","title":"h8GCPJYu"};